import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetTicketTypes, actionDeleteTicketType, actionUpdateMenu, actionSaveRestaurant } from "../../actions/RestaurantActions"
import { LOGIN_ROUTE, TICKET_TYPE_ADD_ROUTE, TICKET_TYPE_EDIT_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Card,
  CardHeader,
  CardMedia,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle, 
  Paper,
  Typography, 
  Fab,
  FormControl,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  TextField,
  Input,
  InputLabel
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibleIcon from '@material-ui/icons/Visibility';
import HideIcon from '@material-ui/icons/VisibilityOff';
import VisibleTDIcon from '@material-ui/icons/PhoneIphone';
import HideTDIcon from '@material-ui/icons/Store';
import MenuIcon from "../../components/MenuIcon"
import ColorIcon from '@material-ui/icons/FiberManualRecord';
import SuggestIcon from '@material-ui/icons/StarRate';
import Util, { ERROR, INFO } from '../../common/Util'
import Roles from "../../config/RolesConstants"
import ImageSelector from '../../components/ImageSelector/ImageSelector'
import ColorField from '../../components/ColorField/ColorField'
import MenuStyleConfig from './MenuStyleConfig'
import Setting from "../../provider/base/Settings"
const MENU_HOST = Setting.MENU_URL_DOMAIN
class TicketTypes extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:25, count:0, tickets:[], filter:"", 
                ticketForDelete:false, canAddEditOrDelete:false, menuOptions:false, 
                urlMenuPreview:""}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.getDeleteTicketSuccess=this.getDeleteTicketSuccess.bind(this)
    this.updateMenuSuccess=this.updateMenuSuccess.bind(this)
    this.onAddTicket=this.onAddTicket.bind(this)
    this.onConfirmDeleteTicket=this.onConfirmDeleteTicket.bind(this)
    this.onSearch=this.onSearch.bind(this)
    this.applyChange=this.applyChange.bind(this)
    this.onChangeMenuBackgroundColor=this.onChangeMenuBackgroundColor.bind(this)
    this.onChangeMenuSuggestTitle=this.onChangeMenuSuggestTitle.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    let canAddEditOrDelete = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN || r.id==Roles.ADMIN})>=0)
    this.setState({canAddEditOrDelete:canAddEditOrDelete,
      urlMenuPreview:`${MENU_HOST}?idCommerce=${this.props.restaurant.id}&${new Date().getTime()}`
    })
    this.props.actionGetTicketTypes(this.onChangePage, this.getTicketsError)
  }

  getTicketsError(e){
    console.log("ERROR AL LISTAR TICKETS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los menúes.")
  }

  onSearch(evt){
    this.setState({filter:evt.target.value}, this.onChangePage)
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let filter = new RegExp(this.state.filter,"ig")
    let tickets = this.props.ticketTypeList.filter((t)=>{return t.tktDisplayName.match(filter)})
    let count = tickets.length
    tickets=tickets.slice(from, end)
    this.setState({page:newPage, count:count, tickets:tickets})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let filter = new RegExp(this.state.filter,"ig")
    let tickets = this.props.ticketTypeList.filter((t)=>{return t.tktDisplayName.match(filter)})
    let count = tickets.length
    tickets=tickets.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, tickets:tickets})
  }

  onAddTicket(){
    this.props.history.push(TICKET_TYPE_ADD_ROUTE)
  }

  onEditTicket(ticket){
    this.props.history.push(TICKET_TYPE_EDIT_ROUTE, ticket)
  }

  onConfirmDeleteTicket(){
    this.props.actionDeleteTicketType(this.state.ticketForDelete.id,this.getDeleteTicketSuccess,this.getDeleteTicketError)
    this.setState({ticketForDelete:false})
  }

  onDeleteTicket(ticket){
    this.setState({ticketForDelete:ticket})
  }

  onChangeVisibility(item){
    this.props.actionUpdateMenu(item.id, {tktVisible:!item.tktVisible}, this.updateMenuSuccess, this.updateMenuError)
  }

  onChangeSuggest(item, count){
    if(count<2||item.mnuIsSuggest){
      this.props.actionUpdateMenu(item.id, {mnuIsSuggest:!item.mnuIsSuggest}, this.updateMenuSuccess, this.updateMenuError)
    }else{
      Util.showNoty(INFO, "Se alcanzó el máximo de sugerencias permitidas")
    }
  }

  onChangeTakeAwayDelivery(item){
    this.props.actionUpdateMenu(item.id, {mnuTakeAwayDelivery:!item.mnuTakeAwayDelivery}, this.updateMenuSuccess, this.updateMenuError)
  }

  updateMenuSuccess(){
    this.props.actionGetTicketTypes(()=>{this.onChangePage(null,this.state.page)}, this.getTicketsError)
  }

  onChangeMenuBackgroundColor(evt){
    this.setState({menuBackgroundColor:evt.target.value})
  }
  
  onChangeMenuSuggestTitle(evt){
    this.setState({menuSuggestTitle:evt.target.value})
  }

  applyChange(menuOptions){
    //TODO Actualizar el comercio los datos del estado
    let res = {...this.props.restaurant,
              resMenuOptions: menuOptions
              // {
              //   headerBackgroundColor:this.state.menuHeaderBackgroundColor,
              //   bodyBackgroundColor:this.state.menuBodyBackgroundColor,
              //   suggest:{
              //     title:this.state.menuSuggestTitle,
              //     backgroundColor:this.state.menuSuggestBackgroundColor,
              //     menu:{
              //       backgroundColor:this.state.menuSuggestItem.backgroundColor,
              //       priceColor:this.state.menuSuggestItem.menuPriceColor,
              //       titleColor:this.state.menuSuggestItem.menuTitleColor,
              //       detailColor:this.state.menuSuggestItem.menuDetailColor
              //     }
              //   },
              //   menu:{
              //     priceColor:this.state.menuPriceColor,
              //     titleColor:this.state.menuTitleColor,
              //     detailColor:this.state.menuDetailColor
              //   }
              }
    this.props.actionSaveRestaurant(res, false, ()=>{
      this.setState({urlMenuPreview:`${MENU_HOST}?idCommerce=${this.props.restaurant.id}&${new Date().getTime()}`
    }),
      console.error
    })
  }
  
  updateMenuError(e){
    console.log("ERROR UPDATE MENU", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al actualizar el menú.")
  }

  getDeleteTicketSuccess(){
    const restaurant = this.props.restaurant
    // console.log("RESTAURANT", restaurant)
    this.props.actionGetTicketTypes(()=>{this.onChangePage(null,this.state.page)}, this.getTicketsError)
  }

  getDeleteTicketError(e){
    console.log("ERROR GET DELETE TICKET", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el menú.")
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Foto del ítem", "Nombre", "Categoría", "Descripción", "Precio Mesa", "Precio Final", "Ítem Visible"] //,  "Creado por", "Modificado por"
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={{...theme.table.actionsColumn, minWidth:200}}>Acciones</TableCell>
    </TableRow>
    )
  }

  /* 
tktIcon
tktIconFamily

tktMaxQtBuy
tktName

tktPriceProducer
tktProducerName
  */

  renderTableBody(){
    const {theme} = this.props
    let tickets = this.state.tickets
    
    if(!tickets||tickets.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    let suggests = tickets.filter((t)=>{return t.mnuIsSuggest})
    return tickets.map((item, index)=>{
      let isActive=item.tktVisible
      let tooltipSuggestMenu =  item.mnuIsSuggest?"Desmarcar como sugerencia":(suggests.length==2?"Se admiten hasta 2 sugerencias":"Marcar como sugerencia")

      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>
            <img src={item.mnuImg} style={{height:37.5, objectFit:"contain"}}/>        
          </TableCell>
          <TableCell>{item.tktDisplayName}</TableCell>
          <TableCell>{item.tktCategory}</TableCell>
          <TableCell>{item.tktDescription}</TableCell>
          <TableCell>{Util.formatCurrency(item.tktTablePrice)}</TableCell>
          <TableCell>{Util.formatCurrency(item.tktPrice)}</TableCell>
          <TableCell style={isActive?theme.table.activeCell:theme.overrides.MuiTableCell.body}>{item.tktVisible?"VISIBLE":"OCULTO"}</TableCell>
          {/* <TableCell>{item.tktCreateUser}</TableCell>
          <TableCell>{item.tktLastUpdateUser}</TableCell> */}
          <TableCell style={{...theme.table.actionsColumn, minWidth:200}}>
            <Tooltip title={item.tktVisible?"Ocultar item de menú":"Mostrar item de menú"}>
              <IconButton onClick={this.onChangeVisibility.bind(this, item)}>
              {item.tktVisible?<HideIcon/>:<VisibleIcon/>}
              </IconButton>
            </Tooltip>
            <Tooltip title={tooltipSuggestMenu}>
              <IconButton onClick={this.onChangeSuggest.bind(this, item, suggests.length)}>
                <SuggestIcon style={{ color: item.mnuIsSuggest?"#FF6E33":undefined}}/>
              </IconButton>
            </Tooltip>
            {/* <Tooltip title={item.mnuTakeAwayDelivery?"Ocultar en take away/delivery":"Mostrar en take away/delivery"}>
              <IconButton onClick={this.onChangeTakeAwayDelivery.bind(this, item)}>
                {item.mnuTakeAwayDelivery?<HideTDIcon/>:<VisibleTDIcon/>}
              </IconButton>
            </Tooltip> */}
           {this.state.canAddEditOrDelete?[
            <Tooltip title="Editar item de menú">
              <IconButton onClick={this.onEditTicket.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip>,
            <Tooltip title="Eliminar item de menú">
              <IconButton onClick={this.onDeleteTicket.bind(this, item)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>]:null}
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, ticketTypeList, restaurant } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">{restaurant.evtName}</Typography>
            <Typography variant="subtitle1">Crea items del menú para el comercio seleccionado</Typography>
          </Box>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de items de menú</Typography>
            {this.state.canAddEditOrDelete?
            <Toolbar style={theme.table.toolbar}>
              <Box style={{display:"flex"}}>
              <Tooltip title="Crear nuevo item del menú">
                <Fab color="primary" onClick={this.onAddTicket} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              <Tooltip title="Opciones de menú digital" style={{marginLeft:8}}>
                <Fab color="secondary" onClick={()=>{this.setState({menuOptions:true})}} size="small">
                  <MenuIcon />
                </Fab>
              </Tooltip>
              </Box>
              <Box>
                <Input placeholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
            :null}
            <Table stickyHeader>
              <TableHead > 
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableBody()}
              </TableBody>
            </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.ticketForDelete}>
            <DialogTitle>Eliminar Menú</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar el item de menú?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button variant="contained" color="secondary" onClick={()=>{this.setState({ticketForDelete:null})}}>Cancelar</Button>
              </Tooltip>
              <Tooltip title="Eliminar tipo de ticket">
                <Button variant="contained" color="primary" onClick={this.onConfirmDeleteTicket}>Eliminar</Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          <MenuStyleConfig  open={this.state.menuOptions}
                            onClose={()=>{this.setState({menuOptions:false})}}
                            onApply={this.applyChange} 
                            menuConfig={restaurant&&restaurant.resMenuOptions}
                            preview={this.state.urlMenuPreview}
          />
          {/* <Dialog open={this.state.menuOptions}>
            <DialogTitle>Opciones de Menú Digital</DialogTitle>
            <Toolbar>
                <TextField label="Título de Sugerencias" value={this.state.menuSuggestTitle} 
                          style={{width:"80%", marginLeft:20}} 
                          onChange={this.onChangeMenuSuggestTitle}/>
                <TextField label="Color de fondo" 
                          value={this.state.menuBackgroundColor} style={{width:100, marginLeft:20}} 
                          inputProps={{type:"color"}}
                          onChange={this.onChangeMenuBackgroundColor}/>
                
            </Toolbar>
            <DialogContent style={{width:600}}>
              <Card>
                <CardMedia height={400}  width={600} component="iframe"
                src={this.state.urlMenuPreview}/>
              </Card>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cerrar">
                <Button variant="contained" color="secondary" onClick={()=>{this.setState({menuOptions:false})}}>Cerrar</Button>
              </Tooltip>
              <Tooltip title="Aplicar cambios">
                <Button variant="contained" color="primary" onClick={this.applyChange}>Aplicar</Button>
              </Tooltip>
            </DialogActions>
          </Dialog> */}
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    ticketTypeList: store.evt.ticketTypeList,
    restaurant: store.evt.restaurant,
    profile: store.auth.profile

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetTicketTypes,
      actionDeleteTicketType,
      actionUpdateMenu,
      actionSaveRestaurant
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(TicketTypes)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/restaurants/TicketTypes.js